
import { NgModule } from '@angular/core';
import { FnSiteSelectionComponent } from './fn-site-selection.component';

export * from './fn-site-selection.component';

@NgModule({
    declarations: [FnSiteSelectionComponent],
    imports: [],
    exports: [FnSiteSelectionComponent]
})
export class FnSiteSelectionModule {

}